import script from "./WishWall.vue?vue&type=script&setup=true&lang=js"
export * from "./WishWall.vue?vue&type=script&setup=true&lang=js"

import "./WishWall.vue?vue&type=style&index=0&id=3dda48b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dda48b4"]])

export default __exports__